import { useEffect, useState } from 'react';

/**
 * Keeps a loading state visible for at least minMs so short async work
 * does not flash the loading UI away before animations can be seen.
 */
const useMinVisible = (loading, minMs = 1200) => {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setElapsed(true), minMs);
    return () => clearTimeout(timeoutId);
  }, [minMs]);

  return loading || !elapsed;
};

export default useMinVisible;
